<span
  class="status-label"
  [class.status-label--small]="size() === 'small'"
  [class.status-label--large]="size() === 'large'"
  [class.status-label--active]="status() === STATUSES.ACTIVE"
  [class.status-label--error]="status() === STATUSES.ERROR"
  [class.status-label--pending]="status() === STATUSES.PENDING"
  [class.status-label--enabled]="status() === STATUSES.ENABLED"
  [class.status-label--disabled]="status() === STATUSES.DISABLED"
  [class.status-label--finished]="status() === STATUSES.FINISHED"
  [class.status-label--failed]="status() === STATUSES.FAILED"
  [class.status-label--in-progress]="status() === STATUSES.IN_PROGRESS"
  [class.status-label--deactivated]="status() === STATUSES.DEACTIVATED"
  [class.status-label--partial]="status() === STATUSES.PARTIAL"
  [class.status-label--blocked]="status() === STATUSES.BLOCKED"
  [class.status-label--duplicate]="status() === STATUSES.DUPLICATE"
  [class.status-label--syncerror]="status() === STATUSES.SYNCERROR"
>
  <fa-icon [icon]="icon()" />

  <span class="status-label__text">
    {{ label() }}
  </span>
</span>
